import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { BoxRevenueStatisticsObject } from '../model/types';

interface Params {
  warehouseId?: string | string[];
  isApplicable?: boolean;
  search?: string;
  startDate?: string;
  endDate?: string;
}

export const getBoxesRevenueStatisticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBoxesRevenueStatistics: build.query<Pagination<BoxRevenueStatisticsObject>, Params>({
      query: (args) => ({
        url: '/warehouses/statistics/boxes-revenue',
        params: args,
      }),
    }),
  }),
});

export const { useGetBoxesRevenueStatisticsQuery } = getBoxesRevenueStatisticsApi;
